import { assertNever } from '@kofno/piper';
import { action, makeObservable, observable } from 'mobx';
import { State } from './States';

export class LoginStore {
  @observable state: State = { kind: 'waiting' };

  constructor() {
    makeObservable(this);
  }

  @action redirecting = (): void => {
    switch (this.state.kind) {
      case 'waiting':
        this.state = { kind: 'redirecting' };
        break;
      case 'redirecting':
      case 'errored':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action errored = (error: unknown): void => {
    switch (this.state.kind) {
      case 'redirecting':
        this.state = { kind: 'errored', error };
        break;
      case 'waiting':
      case 'errored':
        break;
      default:
        assertNever(this.state);
    }
  };
}
